// extracted by mini-css-extract-plugin
export default {"title":"ICIRS31fvTkmX4xwW8vH","text":"DI2rJgHSTHNxh4ATmLJg"};